<template>
  <section class="mt-5 col-md-11 mx-auto">
    <section class="p-md-5">
      <div class="row">
        <div class="p-3 pt-0 pb-5 card-header bg-transparent">
          <div
            class="d-flex flex-row justify-content-between align-items-center"
          >
            <h6 class="mb-0">Cotización # <input type="text" /></h6>
          </div>
        </div>
      </div>
      <div class="row px-3 py-4 bg-dark text-white">
        <div class="col-md-7">
          <div class="d-flex flex-column h-100 justify-content-center">
            <img
              src="https://ventusleasing.mx/wp-content/uploads/2023/04/Logotipo-Ventus-Leasing-Arrendamiento-Puro-Financiamiento-Activos-1-1.png"
              width="200"
            />
          </div>
        </div>
        <div class="col-md-5 text-small">
          <small>
            Torreón<br />
            Carretera San Pedro de las Colinas 2200, Torreón, Coah</small
          >
          <br />
          <small>
            <span>Monterrey</span><br />
            Av. Lázaro Cárdenas 1007, San Pedro Garza García, NL<br />
            ventas@ventusleasing.com | www.ventusleasing.com>
          </small>
        </div>
      </div>
      <div class="row col-md-11 mx-auto">
        <div class="col-md-7">
          <div class="mb-n4">
            <span class="bg-warning px-4 py-1 rounded-bottom text-dark"
              >Cliente</span
            >
          </div>
        </div>
        <div class="col-md-5">
          <div class="mb-n4">
            <span class="bg-warning px-4 py-1 rounded-bottom text-dark"
              >Atención a cliente</span
            >
          </div>
        </div>
      </div>
      <div class="row w-100 m-0">
        <div class="col-lg-11 mx-auto col-sm-12 mt-4">
          <div class="">
            <div class="text-center mt-3">
              <div>
                <span class="badge badge-secondary badge-sm">PENDIENTE</span>
              </div>
            </div>
            <div class="py-3">
              <div class="row">
                <div class="col-md-7">
                  <div>
                    <p>
                      <span><input type="text" class="w-100" /></span><br />
                      <span
                        ><b><input type="text" class="w-100" /></b></span
                      ><br />
                      <span><input type="text" class="w-100" /></span><br />
                      <span><input type="text" class="w-100" /></span><br />
                      <span><input type="text" class="w-100" /></span><br />
                    </p>
                  </div>
                </div>
                <div class="col-md-5">
                  <div>
                    <p>
                      <span>Agente de Ventas - Ventus</span><br />
                      <span>comercial@ventusleasing.com</span><br />
                    </p>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-7">
                  <div class="row my-2 px-3">
                    <div class="col-md-4">
                      <span>Tipo de operación</span>
                    </div>
                    <div class="col-md-8">
                      <div class="bg-light rounded text-center p-1">
                        Arrendamiento Puro
                      </div>
                    </div>
                  </div>
                  <div class="row my-2 px-3">
                    <div class="col-md-4">
                      <span>Valor del bien arrendado</span>
                    </div>
                    <div class="col-md-8">
                      <div class="bg-light rounded text-center p-1">
                        <input type="text" class="text-center w-100" />
                      </div>
                    </div>
                  </div>
                  <div class="row my-2 px-3">
                    <div class="col-md-4">
                      <span>Tipo de equipo</span>
                    </div>
                    <div class="col-md-8">
                      <div class="bg-light rounded text-center p-1">
                        <input type="text" class="text-center w-100" />
                      </div>
                    </div>
                  </div>
                  <div class="row my-2 px-3">
                    <div class="col-md-4">
                      <span>Descripción</span>
                    </div>
                    <div class="col-md-8">
                      <div class="bg-light rounded text-center p-1">
                        <input type="text" class="text-center w-100" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="row my-2 px-3">
                    <div class="col-md-4">
                      <span>Fecha cotización</span>
                    </div>
                    <div class="col-md-8">
                      <div class="bg-dark text-white rounded text-center p-1">
                        <input
                          type="text"
                          class="text-white text-center w-100"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row my-2 px-3">
                    <div class="col-md-4">
                      <span>Fecha vencimiento</span>
                    </div>
                    <div class="col-md-8">
                      <div class="bg-dark text-white rounded text-center p-1">
                        <input
                          type="text"
                          class="text-white text-center w-100"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-11 mx-auto">
        <div class="table-responsive">
          <table class="table text-dark">
            <thead>
              <tr>
                <th class="m-0 p-0 border-bottom border-dark">
                  <div class="bg-dark text-white pt-1 rounded-top px-4">
                    <small>Plazo a<br />seleccionar</small>
                  </div>
                </th>
                <th class="bg-light border-bottom border-dark">
                  <div>
                    <h3>1</h3>
                    <span>Pago inicial total</span><br />
                    <small>Valor neto</small>
                  </div>
                </th>
                <th class="bg-warning border-bottom border-dark">
                  <div>
                    <h3>2</h3>
                    <span>Renta mensual (mas IVA)</span><br />
                    <small
                      ><input type="text" class="text-center w-100 text-xl"
                    /></small>
                  </div>
                </th>
                <th class="bg-light border-bottom border-dark">
                  <div>
                    <h3>3</h3>
                    <span>Opción de compra</span><br />
                    <small
                      >Valor neto
                      <span style="font-size: 9px"
                        >(al finalizar el contrato)</span
                      ></small
                    >
                  </div>
                </th>
                <th class="m-0 p-0 border-bottom border-dark text-center">
                  <div class="bg-dark text-white pt-1 rounded-top px-4">
                    <small>Ahorro estimado<br />de ISR</small>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="text-center text-dark fw-bold">
                <td class="py-4 bg-white border-bottom border-dark">
                  12 Meses
                </td>
                <td class="py-4 bg-light border-bottom border-dark">
                  <input
                    type="text"
                    class="text-center w-100 text-xl fw-bold"
                    style="font-size: 17px"
                  />
                </td>
                <td class="py-4 bg-warning border-bottom border-dark">
                  <input
                    type="text"
                    class="text-center w-100 text-xl fw-bold"
                    style="font-size: 17px"
                  />
                </td>
                <td class="py-4 bg-light border-bottom border-dark">
                  <input
                    type="text"
                    class="text-center w-100 text-xl fw-bold"
                    style="font-size: 17px"
                  />
                </td>
                <td width="10" class="py-4 bg-white border-bottom border-dark">
                  <input
                    type="text"
                    class="text-center w-100 text-xl fw-bold"
                    style="font-size: 17px"
                  />
                </td>
              </tr>
              <tr class="text-center text-dark fw-bold">
                <td class="py-4 bg-white border-bottom border-dark">
                  24 Meses
                </td>
                <td class="py-4 bg-light border-bottom border-dark">
                  <input
                    type="text"
                    class="text-center w-100 text-xl fw-bold"
                    style="font-size: 17px"
                  />
                </td>
                <td class="py-4 bg-warning border-bottom border-dark">
                  <input
                    type="text"
                    class="text-center w-100 text-xl fw-bold"
                    style="font-size: 17px"
                  />
                </td>
                <td class="py-4 bg-light border-bottom border-dark">
                  <input
                    type="text"
                    class="text-center w-100 text-xl fw-bold"
                    style="font-size: 17px"
                  />
                </td>
                <td width="10" class="py-4 bg-white border-bottom border-dark">
                  <input
                    type="text"
                    class="text-center w-100 text-xl fw-bold"
                    style="font-size: 17px"
                  />
                </td>
              </tr>
              <tr class="text-center text-dark fw-bold">
                <td class="py-4 bg-white border-bottom border-dark">
                  36 Meses
                </td>
                <td class="py-4 bg-light border-bottom border-dark">
                  <input
                    type="text"
                    class="text-center w-100 text-xl fw-bold"
                    style="font-size: 17px"
                  />
                </td>
                <td class="py-4 bg-warning border-bottom border-dark">
                  <input
                    type="text"
                    class="text-center w-100 text-xl fw-bold"
                    style="font-size: 17px"
                  />
                </td>
                <td class="py-4 bg-light border-bottom border-dark">
                  <input
                    type="text"
                    class="text-center w-100 text-xl fw-bold"
                    style="font-size: 17px"
                  />
                </td>
                <td width="10" class="py-4 bg-white border-bottom border-dark">
                  <input
                    type="text"
                    class="text-center w-100 text-xl fw-bold"
                    style="font-size: 17px"
                  />
                </td>
              </tr>
              <tr class="text-center text-dark fw-bold">
                <td class="py-4 bg-white border-bottom border-dark">
                  48 Meses
                </td>
                <td class="py-4 bg-light border-bottom border-dark">
                  <input
                    type="text"
                    class="text-center w-100 text-xl fw-bold"
                    style="font-size: 17px"
                  />
                </td>
                <td class="py-4 bg-warning border-bottom border-dark">
                  <input
                    type="text"
                    class="text-center w-100 text-xl fw-bold"
                    style="font-size: 17px"
                  />
                </td>
                <td class="py-4 bg-light border-bottom border-dark">
                  <input
                    type="text"
                    class="text-center w-100 text-xl fw-bold"
                    style="font-size: 17px"
                  />
                </td>
                <td width="10" class="py-4 bg-white border-bottom border-dark">
                  <input
                    type="text"
                    class="text-center w-100 text-xl fw-bold"
                    style="font-size: 17px"
                  />
                </td>
              </tr>
              <tr class="text-center text-dark fw-bold">
                <td class="py-4 bg-white border-bottom border-dark">
                  60 Meses
                </td>
                <td class="py-4 bg-light border-bottom border-dark">
                  <input
                    type="text"
                    class="text-center w-100 text-xl fw-bold"
                    style="font-size: 17px"
                  />
                </td>
                <td class="py-4 bg-warning border-bottom border-dark">
                  <input
                    type="text"
                    class="text-center w-100 text-xl fw-bold"
                    style="font-size: 17px"
                  />
                </td>
                <td class="py-4 bg-light border-bottom border-dark">
                  <input
                    type="text"
                    class="text-center w-100 text-xl fw-bold"
                    style="font-size: 17px"
                  />
                </td>
                <td width="10" class="py-4 bg-white border-bottom border-dark">
                  <input
                    type="text"
                    class="text-center w-100 text-xl fw-bold"
                    style="font-size: 17px"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </section>
</template>

<style scoped>
.bg-dark {
  background: #000 !important;
}

input {
  background-color: transparent;
  border: none;
}
</style>
